
import {BrowserRouter, Routes, Route } from "react-router-dom";
import 'swiper/css';


import ScrollToTop from "./component/layout/ScrollToTop";
import ErrorPage from "./page/404";
import AboutPage from "./page/about";
import BlogPage from "./page/blog";
import BlogPageTwo from "./page/blog-2";
import BlogPageThree from "./page/blog-3";
import BlogSingle from "./page/blog-single";
import CartPage from "./page/cart-page";
import ContactPage from "./page/contact";
import CoursePage from "./page/course";
import CourseSingle from "./page/course-single";
import CourseView from "./page/course-view";
import ForgetPass from "./page/forgetpass";
import Home from "./page/home";
import HomeTwo from "./page/home-2";
import HomeThree from "./page/home-3";
import HomeFour from "./page/home-4";
import HomeFive from "./page/home-5";
import HomeSix from "./page/home-6";
import HomeSeven from "./page/home-7";
import InstructorPage from "./page/instructor";
import LoginPage from "./page/login";
import SearchNone from "./page/search-none";
import SearchPage from "./page/search-page";
import ShopPage from "./page/shop";
import ShopDetails from "./page/shop-single";
import SignupPage from "./page/signup";
import TeamPage from "./page/team";
import TeamSingle from "./page/team-single";

//
import Singing from "./page/singing";
import PerformingArts from "./page/performing-arts";
import FineArts from "./page/fine-arts";
import WesternSingSingle from "./page/Singing/westernsingsingle";
import ClassicalSingSingle from "./page/Singing/classicalsingsingle";
import BeginnerVocalSingle from "./page/Singing/beginnervocalsingle";
import StagePerformanceSingle from "./page/Singing/stageperformancesingle";
import BeginnerTutor from "./page/Tutorprofile/beginnerutor";
import WesternTutor from "./page/Tutorprofile/westerntutor";
import ClassicalTutor from "./page/Tutorprofile/cassicaltutor";
import StageTutor from "./page/Tutorprofile/stagetutor";

import TutorLoginPage from "./page/TutorLoginPage";
import PromotionsPage from "./page/PromotionsPage";
import ViewProfile from "./page/Tutorprofile/viewprofile";
import StudentProfilePage from "./page/StudentProfilePage";
import TutorEditProfile from "./page/Tutorprofile/TutorEditProfile";
//
import "./blackboard.css"
import TermsPage from "./page/TermsPage";
import PrivacyPolicyPage from "./page/PrivacyPolicyPage";
import AllArtsPage from "./page/All-arts";
import CategoryPage from "./page/CategoryPage";
import ExperiencePage from "./page/ExperiencePage";
import CityPage from "./page/cityPage";
import TutorSignupPage from "./page/TutorSignupPage";
//import TutorByCity from "./page/TutorCity";
import ForgotPassword from "./page/ForgotPassword";
import ResetPassword from "./page/ResetPassword";
import EditProfilePage from "./page/EditStudentprofilePage";
import EmailVerification from "./page/EmailVerification";
import BlogDetails from "./page/BlogDetails";
import AdsPage  from "./component/section/AdsPage";
import AdvertisementPage from "./page/AdvertisementPage";	
import PaymentFailed from "./page/PaymentFailed";		
import PaymentSuccess from "./page/PaymentSuccess";
//  basename="/kala"
//   "homepage": "/kala",

function App() {
	return (
		<BrowserRouter   >
			<ScrollToTop />
			{/* 🔥 GLOBAL BLACKBOARD UI WRAPPER */}
      <div className="blackboard-theme">
 
			<Routes>
				<Route path="/" element={<Home />} />
				<Route path="index-2" element={<HomeTwo />} />
				<Route path="index-3" element={<HomeThree />} />
				<Route path="index-4" element={<HomeFour />} />
				<Route path="index-5" element={<HomeFive />} />
				<Route path="index-6" element={<HomeSix />} />
				<Route path="index-7" element={<HomeSeven />} />
				<Route path="course" element={<CoursePage />} />
				<Route path="course-single" element={<CourseSingle />} />
				<Route path="course-view" element={<CourseView />} />
				<Route path="blog" element={<BlogPage />} />
				<Route path="blog-2" element={<BlogPageTwo />} />
				<Route path="/advertise" element={<AdvertisementPage />} />
				<Route path="blog-3" element={<BlogPageThree />} />
				<Route path="blog-single" element={<BlogSingle />} />
				<Route path="about" element={<AboutPage />} />
				<Route path="team" element={<TeamPage />} />
				<Route path="team-single" element={<TeamSingle />} />
				<Route path="instructor" element={<InstructorPage />} />
				<Route path="shop" element={<ShopPage />} />
				<Route path="shop-single" element={<ShopDetails />} />
				<Route path="cart-page" element={<CartPage />} />
				<Route path="search-page" element={<SearchPage />} />
				<Route path="search-none" element={<SearchNone />} />
				<Route path="contact" element={<ContactPage />} />
				<Route path="login" element={<LoginPage />} />
				<Route path="signup" element={<SignupPage />} />
				<Route path="forgetpass" element={<ForgetPass />} />
				<Route path="*" element={<ErrorPage />} />
				<Route path="/blog/:slug" element={<BlogDetails />} />

				
				{/* <Route path="singing" element={<Singing />} /> */}

				<Route path="performing-arts" element={<PerformingArts />} />
				<Route path="fine-arts" element={<FineArts />} />
				<Route path="searchPage" element={<SearchPage />} />
				<Route path="/beginner-vocal" element={<BeginnerVocalSingle />} />
				<Route path="/classical-singing" element={<ClassicalSingSingle />} />
				<Route path="/western-singing" element={<WesternSingSingle />} />
				<Route path="/stage-performance" element={<StagePerformanceSingle />} />
				<Route path="/beginner-tutor" element={<BeginnerTutor />} />
				<Route path="/westerntutor" element={<WesternTutor />} />
				<Route path="/classical-tutor" element={<ClassicalTutor />} />
				<Route path="/stagetutor-tutor" element={<StageTutor />} />
				<Route path="/promotions" element={<PromotionsPage />} />               
				<Route path="/tutor/signup" element={<TutorSignupPage />} />
				<Route path="/tutor/login" element={<TutorLoginPage />} />
				<Route path="/tutor-profile" element={<ViewProfile />} />
				<Route path="/student-profile" element={<StudentProfilePage />} />
				<Route path="/tutor/edit-profile" element={<TutorEditProfile />} />
				<Route path="/terms" element={<TermsPage />} />
				<Route path="/privacypolicy" element={<PrivacyPolicyPage />} />
								<Route path="/morearts" element={<AllArtsPage />} />
			   <Route path="/page/:slug" element={<AdsPage />} />
								{/* <Route path="/tutor/edit-profile" element={<TutorEditProfile />} /> */}

				<Route path="/singing" element={<Singing />} />
                <Route path="/singing/:category" element={<Singing />} />
				{/* <Route path="/tutors/:category" element={<Singing />} /> */}
{/* <Route path="/tutors/:categoryId" element={<Singing />} /> */}
<Route path="/tutors/:categoryName" element={<Singing />} />

{/* <Route path="/category/:categoryName" element={<CategoryPage />} /> */}
        <Route path="/experience/:exp" element={<ExperiencePage />} />
		<Route path="/tutor/:slug" element={<TeamSingle />} />
		{/*<Route path="/tutors/city/:cityName" element={<TutorByCity />} />*/}
		<Route path="/forget-password" element={<ForgotPassword/>} />
		<Route path="/reset-password" element={<ResetPassword/>} />
				<Route path="/edit-student-profile" element={<EditProfilePage/>} />


<Route path="/email-verification" element={<EmailVerification />} />
<Route path="/payment-success" element={<PaymentSuccess />} />
<Route path="/payment-failed" element={<PaymentFailed />} />








			</Routes>
			</div>
		</BrowserRouter>
	);
}

export default App;
